import cn from "classnames";
import List, { type ListProps } from "@/components/common/List";
import { type MultiLevelNavBarItem } from "../../../types";
import NavItem from "../NavItem";
import s from "./NavItemsList.module.scss";

export interface NavItemsListProps
  extends Omit<ListProps<MultiLevelNavBarItem>, "renderItem" | "variant"> {
  heading?: string;
  level?: number;
}

export default function NavItemsList(props: NavItemsListProps) {
  const { heading, level = 0, ...listProps } = props;
  const listClassName = cn(listProps.className, {
    [s.topList]: level === 0,
  });

  return (
    <List
      {...listProps}
      renderItem={(item, index) => {
        return (
          <>
            {heading && index === 0 && (
              <div className={s.heading}>{heading}</div>
            )}
            <NavItem item={item} level={level} />
          </>
        );
      }}
      variant={level === 0 ? "horizontal" : "vertical"}
      className={listClassName}
    />
  );
}
